module.exports = __webpack_public_path__ + "static/media/Livre2.17724f91.png";